export const CHANGE_PAYMENT_TYPE_IN_ORDER = 'change_payment_type_in_order';
export const OWN_PRODUCTS_SET_GLOBUS = 'own_products_set_globus';
export const TEST_MAIN_EMPLOYEE_AB_1 = 'test_main_employee_ab_1';
export const FLAG_AMPLITUDE_INIT = 'amplitude_init';
